// Route names constants.js
export default {
    RN_HOME: "Home",
    RN_USER_SETTINGS: "UserSettings",
    RN_LOGIN: "Login",
    RN_USER_LIST:"UserList",
    RN_INSTITUTIONS:"InstitutionList",
    RN_COMPETENT_AUTHORITIES:"CompetentAuthorities",
    RN_RESET_PASSWORD:"ResetPassword",
    RN_SET_PASSWORD:"ResetPassword",
    RN_RECOMMENDATION_LIST: "RecommendationList",
    RN_PUBLIC_RECOMMENDATION_LIST: "PublicRecommendationList"
}
